var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFaqChassi = function SvgFaqChassi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#faq-chassi_svg__a)",
    d: "M19.553 3.966h-7.618L10.312 8.99l4.249 3.452h2.967l-.021-1.478c0-.413.33-.744.744-.755h2.12c.31 0 .609-.155.785-.413a.98.98 0 0 0 .113-.879l-1.736-4.95z",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#faq-chassi_svg__b)",
    d: "M27.968 10.354h-.734a2.36 2.36 0 0 1 1.51-1.623l.62-.176-.063-.64a1.475 1.475 0 0 0-1.478-1.344H24.02l-1.436-4.238C22.22 1.36 21.29.699 20.267.699h-8.982A2.46 2.46 0 0 0 8.98 2.322l-1.427 4.3-5.365.031c-.775 0-1.405.58-1.478 1.344l-.051.63.6.187a2.36 2.36 0 0 1 1.508 1.623h-.734c-.816 0-1.488.671-1.488 1.488v3.887a1.486 1.486 0 0 0 1.51 1.488l5.188-.041c.817 0 1.489-.672 1.489-1.489v-.465c0-.393.155-.765.434-1.044a1.47 1.47 0 0 1 1.044-.434h.775a1.49 1.49 0 0 1 1.468 1.478v.434c0 .817.672 1.478 1.488 1.478h4.755c.817 0 1.489-.661 1.489-1.488v-.651a1.34 1.34 0 0 1 1.334-1.344h.888c.734.01 1.333.61 1.333 1.344v.692c0 .807.662 1.478 1.468 1.489l2.74.041h.02a1.47 1.47 0 0 0 1.044-.434c.29-.28.445-.662.445-1.054v-3.97c0-.816-.672-1.488-1.489-1.488m-2.677 5.416v-.692c0-1.582-1.292-2.884-2.874-2.884h-.878c-.796-.031-1.5.279-2.047.827a2.92 2.92 0 0 0-.858 2.046l.062.59-4.693.062v-.435a3.033 3.033 0 0 0-3.008-3.018h-.765c-.827-.01-1.581.3-2.15.868a2.98 2.98 0 0 0-.889 2.15v.404H4.793l-2.677.103-.062-3.825h2.388v-.775c-.01-1.395-.59-2.377-1.261-3.008h3.37l2.088-.041 1.798-5.282a.92.92 0 0 1 .858-.61h8.983c.382 0 .723.248.858.63l1.819 5.23h.527l3.411-.04a4.17 4.17 0 0 0-1.344 3.11v.642h2.367l.062 3.907-2.677.03z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "faq-chassi_svg__a",
    x1: 15.819,
    x2: 15.819,
    y1: 12.442,
    y2: 3.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "faq-chassi_svg__b",
    x1: 15.001,
    x2: 15.001,
    y1: 17.301,
    y2: 0.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })))));
};
export default SvgFaqChassi;